import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { MatToolbarModule } from '@angular/material/toolbar'
import { ProductSideMenuComponent } from './product-side-menu/product-side-menu.component'
import { RouterModule } from '@angular/router'
import { ProductService } from '../../services/product.service'
import { WindowService } from '../../services/window.service'

@Component({
  selector: 'app-product',
  imports: [MatToolbarModule, ProductSideMenuComponent, RouterModule],
  templateUrl: './product.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product.component.scss',
})
export class ProductComponent implements OnInit {
  productService = inject(ProductService)
  windowService = inject(WindowService)

  isMobileView: boolean = false

  ngOnInit() {
    /**
     * Subscribe to window resize changes programmatically as components conditionally shown using css media queries (.desktop-view, .mobile-view)
     * are initialized regardless as it is at the presentation layer and does not affect the initialization of the components in the DOM.
     */
    this.windowService.isMobileView$.subscribe((isMobileView) => {
      this.isMobileView = isMobileView
    })
  }
}
